import script from "./DataStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./DataStatus.vue?vue&type=script&setup=true&lang=js"

import "./DataStatus.vue?vue&type=style&index=0&id=abc26474&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-abc26474"]])

export default __exports__